import './App.css';
import Nav from './components/navigation/nav';
import { Routes, Route } from "react-router-dom";
import Home from './pages/home'
import About from './pages/about';
import ContactPage from './pages/contact';
import Footer from './components/footer';
import SignUpPage from './pages/signup';
import { UserContextProvider } from './context/UserContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/login';
import PropertiesPage from './pages/properties';
import SiteFeaturesPage from './pages/siteFeatures';
import PnlPage from './pages/pnl';
import PropertyPnlSnapshotPage from './pages/propertyPnlSnapshot';
import PropertyInvestmentsPage from './pages/propertyInvestments';
import PropertyUtilitiesPage from './pages/propertyUtilities';
import PropertySuppliesPage from './pages/propertySupplies';
import PropertyBookingsCalendarPage from './pages/propertyBookingsCalendar';
import InvestmentsPage from './pages/investments';
import ReceiptsPage from './pages/receipts';
import CleaningMarketplacePage from './pages/cleaningMarketplace';
import SignupRequestsPage from './pages/signupRequests';
import SignupPendingPage from './pages/signupPending';
import BlogPage from './pages/blog';
import BlogPostPage from './pages/blogPost';
import PublicBookingPage from './pages/publicBooking';
import DirectBookingManagerPage from './pages/directBookingManager';
import ChatPage from './pages/chat';
import GuestChatPage from './pages/guestChat';
import PublicListingsPage from './pages/publicListings';
import TripsPage from './pages/trips';
import OperationsPage from './pages/operations';
import TravelPage from './pages/travel';
import HostDashboard from './pages/hostDashboard';
import ProfilePage from './pages/profile';
import PropertyCreatePage from './pages/propertyCreate';
import CohostOnboardingPage from './pages/cohostOnboarding';
import TasksPage from './pages/tasks';
import PropertiesUtilitiesPage from './pages/propertiesUtilities';
import ForgotPasswordPage from './pages/forgotPassword';
import ResetPasswordPage from './pages/resetPassword';
import CleanerDashboard from './pages/cleanerDashboard';

function App() {
  return (
    <UserContextProvider>
        <div className="app">
        <Nav items={["About", "Contact", "Blog", "Listings", "Properties", "Tasks", "Operations", "Cleaners", "CleanerDashboard", "Travel", "Chat", "Trips"]} />
        <div className="content">
          <Routes>
            <Route path="/">
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog/:slug" element={<BlogPostPage />} />
              <Route path="listings" element={<PublicListingsPage />} />
              <Route path="book/:slug" element={<PublicBookingPage />} />
              <Route path="guest-chat/:conversationId" element={<GuestChatPage />} />
              <Route path="signup" element={<SignUpPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />
              <Route path="signup-pending" element={<SignupPendingPage />} />
              <Route element={<ProtectedRoute />}>
                <Route path="Properties" element={<PropertiesPage />} />
                <Route path="CohostOnboarding/:propertyId" element={<CohostOnboardingPage />} />
                <Route path="Properties/new" element={<PropertyCreatePage />} />
                <Route path="Properties/utilities" element={<PropertiesUtilitiesPage />} />
                <Route path="PropertyDetails/:propertyId" element={<SiteFeaturesPage />} />
                <Route path="PropertyDetails/:propertyId/direct-booking" element={<DirectBookingManagerPage />} />
                <Route path="PropertyDetails/:propertyId/pnl" element={<PropertyPnlSnapshotPage />} />
                <Route path="PropertyDetails/:propertyId/investments" element={<PropertyInvestmentsPage />} />
                <Route path="PropertyDetails/:propertyId/utilities" element={<PropertyUtilitiesPage />} />
                <Route path="PropertyDetails/:propertyId/supplies" element={<PropertySuppliesPage />} />
                <Route path="PropertyDetails/:propertyId/bookings-calendar" element={<PropertyBookingsCalendarPage />} />
                <Route path="Chat" element={<ChatPage />} />
                <Route path="Tasks" element={<TasksPage />} />
                <Route path="Trips" element={<TripsPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="direct-booking-dashboard" element={<HostDashboard />} />
                <Route path="Operations" element={<OperationsPage />} />
                <Route path="Travel" element={<TravelPage />} />
                <Route path="Receipts" element={<ReceiptsPage />} />
                <Route path="Investments" element={<InvestmentsPage />} />
                <Route path="Pnl" element={<PnlPage />} />
                <Route path="Cleaners" element={<CleaningMarketplacePage />} />
                <Route path="CleanerDashboard" element={<CleanerDashboard />} />
                <Route path="SignupRequests" element={<SignupRequestsPage />} />
              </Route>
            </Route>
          </Routes>
          </div>
          <Footer />
      </div>
    </UserContextProvider>
  );
}

export default App;
